import { render, staticRenderFns } from "./BanquetChannelSource.vue?vue&type=template&id=a4509c60&scoped=true&"
import script from "./BanquetChannelSource.vue?vue&type=script&lang=js&"
export * from "./BanquetChannelSource.vue?vue&type=script&lang=js&"
import style0 from "./BanquetChannelSource.vue?vue&type=style&index=0&id=a4509c60&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a4509c60",
  null
  
)

export default component.exports